import * as Yup from 'yup';

export const ThirdPartySchema = Yup.object().shape({
  birthDate: Yup.date().typeError('La date doit être valide').nullable(),
});
